import React, { Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { host } from '../../../configuraciones';
import ModalMensajeComponent from '../../App/ModalMensajeComponent';
import GetAppIcon from '@mui/icons-material/GetApp';
import { IconButton } from '@mui/material';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import JSZip from 'jszip';
function BotonDescargarArchivosComponent(props) {
    const dispatch = useDispatch()
    let entregashologramas = props.entregashologramas
    const [openModal, setOpenModal] = React.useState(false)

    const downloadSolicitud = async () => {

        if (entregashologramas !== null && entregashologramas !== undefined && entregashologramas.length > 0) {
            let blobs = []
            await dispatch(actualizarLoadingApp_true())
            for (const holograma of entregashologramas) {
                const fileFetch = await fetch(host + `ModuloEntregas/servirAchivos/nameTabla=${'documentoshologramas'}&nameFK=${'identrega'}&idSolicitud=${holograma.identrega}`, {
                    method: 'GET',
                    headers: {
                        'authorization': localStorage.getItem('user'),
                        'refresh-authorization': localStorage.getItem('refreshToken'),
                        'Content-Type': 'application/json'
                    },
                })
                if (fileFetch.status != 404) {
                    const blob = await fileFetch.blob();
                    blobs.push(blob)
                }
            }
            const zip = new JSZip();
            blobs.forEach((blob, index) => {
                const fileName = `ReciboHolograma${index + 1}.pdf`;
                zip.file(fileName, blob);
            });
            await dispatch(actualizarLoadingApp_false())
            zip.generateAsync({ type: 'blob' }).then((content) => {
                const zipUrl = URL.createObjectURL(content);
                const downloadLink = document.createElement('a');
                downloadLink.href = zipUrl;
                downloadLink.download = 'RecibosHologramas.zip';
                downloadLink.click();

                URL.revokeObjectURL(zipUrl);
            });
        }
    }
    return (
        <Fragment>
            <IconButton onClick={() => downloadSolicitud()}>
                <GetAppIcon sx={{ color: 'black' }}></GetAppIcon>
            </IconButton>
            {openModal &&
                <ModalMensajeComponent setOpenModal={{ setOpenModal }} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
            }
        </Fragment>
    )
}

export default BotonDescargarArchivosComponent